import { useTranslation } from "react-i18next"

import useSiteTitle from "../hooks/use-site-title"
import useCustom from "../hooks/use-Custom"

import LegalPageContent from "../components/LegalPageContent/LegalPageContent"
import SEO from "../components/SEO/SEO"

const CookiesPolicy = () => {
  const { t } = useTranslation()

  const title = t("Cookies Policy")

  const { isCustom } = useCustom()
  const siteTitle = useSiteTitle(isCustom)

  return (
    <LegalPageContent>
      <SEO title={title} description={title} siteTitle={siteTitle} />
      <h1>{title}</h1>
      <div dangerouslySetInnerHTML={{ __html: t("cookiesText") }}></div>
    </LegalPageContent>
  )
}

export default CookiesPolicy
